export default "__VITE_ASSET__DaNEdSHN__"